module.exports = __webpack_public_path__ + "static/media/g2w_map_row_logo.03b309dc.png";